export default __webpack_public_path__ + "static/img-ei-12-b7ac789de8c782f3f957897271478d49.png";